<template>
	<v-card height="600" class="mb-3">
        <v-toolbar color="indigo darken-3" dark height="40" class="amenitiesSearchToolbar">
            <v-toolbar-title width="100%" style="width: 100%;">
                <v-layout row align-center justify-space-between>
                    <v-flex class="subheading">Amenities Search</v-flex>
                    <v-flex class="text-xs-right">
                    	<v-btn icon small style="transform: scale(.9);"><v-icon @click="setShowHelpRoomAmenities(true)">help</v-icon></v-btn>
                    	<v-btn icon small><v-icon @click="closeAmenitySearch" >close</v-icon></v-btn>
                    </v-flex>
                </v-layout>                                 
            </v-toolbar-title>            
        </v-toolbar>
        <v-card-text>  
        	<v-form v-model="valid" ref="form">      	
				<v-select 
		          :items="listOfLists"
		          item-text="listname"
		          item-value="listname"
		          label="Choose Amenities List"
		          outline
		          return-object
		          @change="listChanged"
		          v-model="selectedList">
		        </v-select>

		        <v-select v-if="listDefinition"
		          :items="listDefinition && listDefinition.list"
		          item-text="label"
		          item-value="label"
		          label="Select Amenity"
		          outline
		          return-object
		          v-model="selectedAmenity">
		          	<template slot="item" slot-scope="{ item, tile }">
				        <v-list-tile-content>
					        <v-list-tile-title>
					        	<v-layout row justify-space-between>
					        		<v-flex>{{item.label}}</v-flex>
					        		<v-flex class="caption text-xs-right">{{item.dataType}}</v-flex>
					        	</v-layout>
					        </v-list-tile-title>
				        </v-list-tile-content>
				    </template>
				    <template slot="selection" slot-scope="{ item, tile }">
				        <v-list-tile-content>
					        <v-list-tile-title>
					        	<v-layout row justify-space-between>
					        		<v-flex>{{item.label}}</v-flex>
					        		<v-flex class="caption text-xs-right">{{item.dataType}}</v-flex>
					        	</v-layout>
					        </v-list-tile-title>
				        </v-list-tile-content>
				    </template>
		        </v-select>	

		        <v-select v-if="selectedAmenity"
		          :items="operands"
		          item-text="label"
		          item-value="value"
		          label="Select Operand"
		          outline
		          :disabled="selectedAmenity.dataType=='Allowed Values' ||  selectedAmenity.dataType=='Boolean'"
		          v-model="selectedOperand">
		          	
		        </v-select>	

		        <v-select v-if="selectedAmenity && selectedAmenity.dataType=='Boolean'"
		          :items="[{label: 'True', value: '1'}, {label: 'False', value: '0'}]"
		          item-text="label"
		          item-value="value"
		          label="Select True/False"
		          outline
		          v-model="selectedSearchValue">
		        </v-select>
		        <v-select v-if="selectedAmenity && selectedAmenity.dataType == 'Allowed Values'"
					v-model="selectedSearchValue" 
					label="Select Value"
					:items="selectedAmenity.allowedValues.map((item) => item.value )"
					@input="changed = true"
					outline>
				</v-select>
		        <v-text-field v-if="selectedAmenity && ( selectedAmenity.dataType!='Boolean' && selectedAmenity.dataType!='Allowed Values') "
		          label="Enter Value"
		          :rules="rules(selectedAmenity.dataType)"
		          autofocus
		          outline
		          return-object
		          v-model="selectedSearchValue">
		        </v-text-field>	
	        </v-form>	
	        <v-btn v-if="selectedAmenity" @click="addToSearch" dark color="blue darken-3">
	        	Add to Search</v-btn>	
	        <div v-if="search" class="pt-2" >
	        	<v-flex class="caption ml-2 mb-1" style="color: grey;">Search Criteria</v-flex>
	        	<v-layout class="ml-2" row v-for="(item, index) in search" :key="index" justify-space-between>
	        		<v-flex xs5>{{item.label}}</v-flex>
	        		<v-flex xs1>{{item.operand}}</v-flex>
	        		<v-flex xs5 class="text-xs-right mr-2">{{formatValue(item)}}</v-flex>
	        		<v-tooltip top>
	        		<v-flex xs1 slot="activator"><v-icon small color="red lighten-2" 
	        			@click="search.splice(index,1)">close</v-icon>
	        		</v-flex>
	        		Clear
	        		</v-tooltip>
	        	</v-layout>
	        	<v-btn class="mt-3" color="#a70000" dark @click="submitSearch">Search</v-btn>
	        </div>    
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import moment from 'moment'

export default {
data () {
	return {	listOfLists: 	[{listname: 'Loading...'}],
				listDefinition: null,
				selectedList: 	null,
				selectedAmenity: null,
				selectedOperand: '=',
				selectedSearchValue: null,
				search: null,
				valid: false,
				operands: [ { label: 'EQUALS', 				value: '='  }, 
							{ label: 'IS GREATER THAN',		value: '>'  },
							{ label: 'IS LESS THAN',		value: '<'  }, 
						  ]
	}
},

created: async function () {
	this.listOfLists = await this.fetchAmenitiesListOfLists()
},

computed: {
	...mapState({   	buildings: state => state.space.buildings,
				})
},

methods : {
	...mapMutations([ 	'setSearchResults',
                        'setLoading',
                        'setSearchTitle',
                        'setSearchSubtitle',
                        'updateSearchResultSidebar',
                        'updateMainSidebar',
                        'setSnackText',
                        'setShowHelpRoomAmenities',
                        'setSearchExportText',
					]),
	...mapActions([		'fetchAmenitiesListOfLists', 'fetchAmenitiesList', 
						'fetchSearchRoomAmenities' 
				  ]),
	
	rules: function (dataType) {
		if (dataType=='Boolean') { 
			return [ v => !!v || "Field is required", ] 
		}
		if (dataType=='Number') { 
			return [ v => !isNaN(v) || !v || 'Must be a number.', ] 
		}
		if (dataType=='Integer') { 
			return [ v => this.isInteger(v) || !v || 'Must be an Integer.', ] 
		}
		if (dataType=='Date') { 
			return [ v => this.isDate(v) || !v || 'Must be a Date. MM/DD/YYYY', ] 
		}
	},

	isInteger: function (str) {
	    var n = Math.floor(Number(str));
	    return n !== Infinity && String(n) === str && n >= 0;
	},

	isDate: function (str) {
		return moment(str, "MM/DD/YYYY", true).isValid()
	},

	listChanged: async function () {
		this.listDefinition = await this.fetchAmenitiesList({ key: this.selectedList.key })
	},

	addToSearch: function () {
		if (!this.valid) { console.log("Form Not Valid"); return }
		if (!this.search) { this.search = [] }
		if (this.search.find((row) => {return row.amenitykey === this.selectedAmenity.key })) {
			this.setSnackText("Duplicate Amenity in Search")
			return 
		}
		this.search.push({ 	'amenitykey': 	this.selectedAmenity.key,
							'label':  		this.selectedAmenity.label,
							'operand':   	this.selectedOperand, 
							'dataType':		this.selectedAmenity.dataType,
							'value': 		this.selectedSearchValue,
		})
		this.selectedSearchValue = null
		this.selectedAmenity = null
	},

	closeAmenitySearch : function () {
		this.$emit('closeAS')
	},

	formatValue: function (item) {
		if (item.dataType=="Boolean") {
			return item.value == '1' ? 'True' : 'False'
		}
		return item.value
	},

	queryText: function (searchPayload) {
		let niceText = ""
		searchPayload.forEach((row) => {
			niceText += `${row.label} ${row.operand} ${this.formatValue(row)}` + "<br>"
		})

        return niceText
    },

	submitSearch() {		
        this.fetchSearchRoomAmenities(this.search).then((data) => {
            if (!data || data == "No Rooms Found") {
                this.setSnackText("No Results Found");  
                this.setLoading(false)
                return
            }

            // Collapse smaller sites into one site "Other Sites"
                
                let newData = JSON.parse(JSON.stringify(data)) // Deep Copy
                newData.sites = []
                let otherBuildings = []

                data.sites.forEach((site) => {
                    
                    // if this site is not Main, Phx, or South, collect all the buildings together into an array.
                    if (site.siteID != '10' && site.siteID != '19' && site.siteID != '108') {
                        site.buildings.forEach((bldg) => {
                            otherBuildings.push(bldg)
                        })                         
                    } else { 
                        // else just push this site into the return (newData) whole                           
                        newData.sites.push(site)
                    }
                })

                // Build the "Other" site
                if (otherBuildings.length > 0) {
                    newData.sites.push({'siteID': 'Other', 'siteName': 'Other Sites', 'buildings': otherBuildings})
                }

            
            this.setSearchResults(newData) 

            //this.setSearchResults(data)    // Using this instead will detail out each individual site
            //this.updateMainSidebar(false)                   

            

            const subtitle =    `<div style="background-color: #30302E;color: white;padding: 25px;margin-left: -25px;
                                        margin-top: -25px;">
                                        <div class="headline">
                                        ${this.queryText(this.search)}
                                        </div>
                                        <div>Total Area: ${data.areaSum.toLocaleString()}</div>
                                        <div>Bldg Count: ${data.bldgCount.toLocaleString()}</div>
                                        <div>Room Count: ${data.roomCount.toLocaleString()}</div>

                                `

            this.setSearchTitle("Room Search")
            this.setSearchSubtitle(subtitle)              
            this.updateSearchResultSidebar(true)
            this.setLoading(false)

            const regexBr 	= new RegExp('<br>', 'gi');
			let nicerText 	= this.queryText(this.search).replace(regexBr, ' & ');
			nicerText 		= nicerText.slice(0, -3) // take last two chars off*/
			this.setSearchExportText(nicerText) // Used 
        }) 
    },
},
}

</script>

<style>
.amenitiesSearchToolbar .v-toolbar__content {
	padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/roomAmenities/AmenitiesSearch.vue